import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    firstEmoji: null,
};

export const ImageStoreSlice = createSlice({
    name: "ImageStoreSlice",
    initialState,
    reducers: {
        EditEmojiImage: (state, action) => {
            state.firstEmoji = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { EditEmojiImage } = ImageStoreSlice.actions;

export default ImageStoreSlice.reducer;
